import { AfterViewInit, Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalRegistroJucespComponent } from '../shared/modal/modal-registro-jucesp/modal-registro-jucesp.component';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ModalInformativoJucespComponent } from '../shared/modal/modal-informativo-jucesp/modal-informativo-jucesp.component';
import { ServicosGeraisService } from '../services/servicos-gerais.service';
import { ErrorService } from '../services/error.service';



@Component({
  selector: 'app-registro-jucesp',
  templateUrl: './registro-jucesp.component.html',
  styleUrls: ['./registro-jucesp.component.scss']
})
export class RegistroJucespComponent implements OnInit {

  msgErro: boolean = false;
  loginAuth: string;
  localExibicao: any;
  tipoPortal: any;
  dados: any

  constructor(
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private service: ServicosGeraisService,
    private errorService: ErrorService,
  ) { }

  ngOnInit() {

    this.loadComunicado();

    this.route.queryParams.subscribe(
      (queryParams: any) => {
        if (queryParams['tkLogin']) {
          sessionStorage.setItem('loginAuth', queryParams['tkLogin']);
        }
      }
    );

    if(environment.mockToken){
      this.loginAuth = ''      
    } else {
      this.loginAuth = sessionStorage.getItem('loginAuth');
    }    
        
  }

  loadComunicado() {
    this.localExibicao = "JUNTA_COMERCIAL";
    this.tipoPortal = "INTEGRADOR"
    this.service.getComunicado(this.localExibicao,this.tipoPortal)
    .then((res) => {
      if(res != ""){
        this.dados = JSON.parse(res);
        if (this.dados.statusComunicado == 'ATIVO') {
          this.openModalComunicado(this.dados);
        }
      }
    }).catch((erro) => {
      this.errorService.error(erro);
    });
  }

  openModalComunicado(dados: any) {
    const modal = this.modalService.open(ModalInformativoJucespComponent, {
      size: 'lg',
      centered: true,
      keyboard: false,
      backdrop: 'static'
    });
    modal.componentInstance.dados = this.dados;
  }  

  openModalRegistroJucesp() {
    this.modalService.open(ModalRegistroJucespComponent, { size: 'lg', centered: true, backdrop: 'static', keyboard: false });
  }

  linkVRE(){
    window.location.href = environment.linkVRE + this.loginAuth;
  }

  linkRegistro(){
    window.location.href =  environment.linkRegistro + this.loginAuth;
  }


}
